export default state => state.trolley.loading;
